import React from "react";
import styled from "styled-components";
import { Colors } from "../../utils/colors";

const Btn = styled.button`
  font-family: "Poppins", sans-serif;
  border-radius: 10px;
  font-size: 16px;
  background-color: ${Colors.primaryColor};
  padding: 6px 11px;
  margin-right: 21px;
  text-transform: capitalize;
  border: none;
  cursor: pointer;
  color: white;
  font-weight: 700;
  max-width: 191px;
  width: 100%;
  height: 58px;
  &:hover {
    opacity: 1;
    transition-duration: 0.6s;
    background: rgb(131 91 199);
  }
  @media (max-width: 767px) {
    padding: 11px 10px;
    height: 45px;
    font-size: 12px;
    margin: 13px 5px 0px 0px;
  }
  @media (min-width: 394px) and (max-width: 575px) {
    padding: 11px 10px;
    margin: 19px 3px 0px 0px;
    width: 24%;
    font-size: 10px;
  }
`;

interface IProps {
  text: string;
  color?: string;
  style: React.CSSProperties;
}

const Button = ({ text, style }: IProps) => {
  return <Btn style={style} >{text}</Btn>;
};

export default Button;
